import { app } from '../../../bootstrap/core';
import { statusVerifyState } from './verify.state';
import { statusVerifyComponent } from './verify.component';
import './components/statusVerifyModal/statusVerifyModal';

app.config(statusVerifyState);
app.component(statusVerifyComponent.name, statusVerifyComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/verify/verify.js